export const stepConfig = [
  {target: '.StepOne', key: 'workspaceInsights'},
  {target: '.StepTwo', key: 'userInsights'},
  {target: '.StepThree', key: 'courseInsights'},
];
